import React, {useMemo, useEffect, useState} from "react";
import {Button, Typography, Form, Select} from "antd";
import {PlusOutlined, DeleteOutlined} from "@ant-design/icons";
import {FormInputV2} from "../../components/form/index.jsx";
import {StatisticsLabel} from "../../admin/components/StatisticsLabel.jsx";
import {initialItem} from "./utils.jsx";
import {numberWithCommas} from "../../utils/StringFormat.jsx";
import {StyledButton} from "../../components";
import {FoodRequestsIdToName} from "../../marketplace/ProductsFilterModal/consts.jsx";
import "../briefs.css";
import isMobileDevice from "is-mobile";
import {getLogger} from "../../Logger.jsx";

export const ProviderBidItems = ({formItems, setFormValues, form}) => {
    const [items, setItems] = useState(formItems ?? [initialItem]);

    const log = useMemo(() => getLogger({}, "ProviderBidItems"), []);

    const foodRequestOptions = Object.entries(FoodRequestsIdToName).map(([value, label]) => ({value, label}));

    useEffect(() => {
        log("useEffect", {formItems, form});
        const initialItems = (formItems ?? [initialItem]).map(item => ({
            ...item,
            key: item.key || Date.now() + Math.random()
        }));
        setItems(initialItems);

        if (form) {
            form.setFieldsValue({
                package: {
                    options: initialItems
                }
            });
        }
    }, [formItems, form, log]);

    const addItem = () => {
        log("addItem");
        const newItem = {...initialItem, key: Date.now() + Math.random()};
        const newItems = [...items, newItem];
        setItems(newItems);
        setFormValues(prev => ({
            ...prev,
            package: {
                ...prev.package,
                options: newItems
            }
        }));
    };

    const handleItemChange = (key, field, value) => {
        log("handleItemChange", {key, field, value});
        const newItems = items.map(item => (item.key === key ? {...item, [field]: value} : item));
        setItems(newItems);
        setFormValues(prev => ({
            ...prev,
            package: {
                ...prev.package,
                options: newItems
            }
        }));
    };

    const removeItem = key => {
        log("removeItem", {key});
        const newItems = items.filter(item => item.key !== key);
        const finalItems = newItems.length ? newItems : [{key: Date.now(), ...initialItem}];
        setItems(finalItems);
        setFormValues(prev => ({
            ...prev,
            package: {
                ...prev.package,
                options: finalItems
            }
        }));
    };

    const totalBidSum = useMemo(() => {
        return items.reduce((acc, item) => acc + (item.amount || 0) * (item.price || 0), 0);
    }, [items]);

    useEffect(() => {
        setFormValues(prev => ({...prev, price: totalBidSum}));
    }, [totalBidSum, setFormValues]);

    return (
        <div style={{marginTop: 20}}>
            {items.map((item, index) => (
                <div
                    key={item.key}
                    style={{
                        display: "flex",
                        gap: 8,
                        marginBottom: 8,
                        direction: "rtl",
                        ...(isMobileDevice() && {flexFlow: "wrap"})
                    }}>
                    <Form.Item
                        name={["package", "options", index, "name"]}
                        rules={[{required: true, message: "יש להזין שם פריט"}]}
                        style={{width: "30%", ...(isMobileDevice() && {width: "45%"})}}
                        label="שם הפריט"
                        className="label-text">
                        <FormInputV2
                            placeholder="שם הפריט"
                            // value={item.name}
                            onChange={e => handleItemChange(item.key, "name", e.target.value)}
                        />
                    </Form.Item>
                    <Form.Item
                        name={["package", "options", index, "sku"]}
                        style={{width: "15%", ...(isMobileDevice() && {width: "50%"})}}
                        label="מק''ט (לא חובה)"
                        className="label-text">
                        <FormInputV2
                            placeholder="מק''ט"
                            // value={item.sku}
                            onChange={e => handleItemChange(item.key, "sku", e.target.value)}
                        />
                    </Form.Item>
                    <Form.Item
                        name={["package", "options", index, "amount"]}
                        style={{width: "15%", ...(isMobileDevice() && {width: "25%"})}}
                        label="כמות"
                        rules={[{required: true, message: "יש להזין כמות"}]}
                        className="label-text">
                        <FormInputV2
                            placeholder="כמות"
                            type="number"
                            // value={item.amount}
                            onChange={e => handleItemChange(item.key, "amount", parseFloat(e.target.value))}
                        />
                    </Form.Item>
                    <Form.Item
                        name={["package", "options", index, "price"]}
                        style={{width: "15%", ...(isMobileDevice() && {width: "70%"})}}
                        label="מחיר לפריט כולל מע״מ"
                        rules={[{required: true, message: "יש להזין מחיר"}]}
                        className="label-text">
                        <FormInputV2
                            placeholder="מחיר לפריט (כולל מע״מ)"
                            type="number"
                            // value={item.price}
                            onChange={e => handleItemChange(item.key, "price", parseFloat(e.target.value))}
                        />
                    </Form.Item>
                    <Form.Item
                        name={["package", "options", index, "foodRequests"]}
                        style={{width: "20%", ...(isMobileDevice() && {width: "80%"})}}
                        label="התאמות תזונתיות"
                        className="label-text">
                        <Select
                            mode="multiple"
                            // value={item.foodRequests || null}
                            placeholder="התאמות תזונתיות"
                            style={{height: "40px", borderRadius: 5, width: "100%"}}
                            options={foodRequestOptions}
                            onChange={value => handleItemChange(item.key, "foodRequests", value)}
                        />
                    </Form.Item>
                    <Button
                        icon={<DeleteOutlined />}
                        style={{height: "40px", borderRadius: 5, width: 40, alignSelf: "end", marginBottom: "24px"}}
                        danger
                        onClick={() => removeItem(item.key)}
                    />
                </div>
            ))}
            <div
                style={{
                    display: "flex",
                    flexFlow: "wrap",
                    justifyContent: "start",
                    alignItems: "center",
                    marginTop: 16,
                    gap: 10
                }}>
                <StyledButton
                    className="add-item-btn"
                    onClick={addItem}
                    style={{...(isMobileDevice() && {width: "100%"})}}>
                    הוספת פריט
                </StyledButton>

                <StatisticsLabel
                    style={{...(isMobileDevice() && {width: "100%"})}}
                    title={
                        <span>
                            סכום הצעה מעודכן:
                            <span> {numberWithCommas(totalBidSum?.toFixed(0))}</span>₪
                        </span>
                    }
                />
            </div>
        </div>
    );
};
